import { Env } from "./env";

export const BASE_URL_ADMIN_CONSOLE = Env.IsProduction()
  ? "https://admin-addify.com"
  : "https://staging.admin-addify.com";

export const BASE_URL_ORIGINAL_PADDOCKS = Env.IsProduction()
  ? "https://paddocks.getaddify.com"
  : "https://paddocks.getaddify-staging.com";

export const BASE_ONBOARDING = Env.IsProduction()
  ? "https://onboarding.getaddify.com"
  : "https://onboarding.getaddify-staging.com";

export const BASE_DOCUMENT_SERVICE = Env.IsProduction()
  ? `https://api.documents.getaddify.com`
  : `https://api.documents.getaddify-staging.com`;

export const BASE_ACCOUNT_MANAGEMENT_SERVICE = Env.IsProduction()
  ? `https://api.getaddify.com`
  : `https://api.getaddify-staging.com`;

export const BASE_POLICY_SERVICE = Env.IsProduction()
  ? `https://api.getaddify.com/policy`
  : `https://api.getaddify-staging.com/policy`;
